var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(
                                            " 是否可接受在無塵室穿戴無塵服及手套工作 "
                                          ),
                                          _c("p", { staticClass: "en-text" }, [
                                            _vm._v(
                                              "Can accept wear clean suit and gloves at work inside clean room"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "field-radio" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanWorkAtCleanRoom,
                                              expression:
                                                "workCondition.CanWorkAtCleanRoom",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              _vm.workCondition
                                                .CanWorkAtCleanRoom,
                                              true
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanWorkAtCleanRoom",
                                                true
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("是 (Yes)")]),
                                      ]),
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanWorkAtCleanRoom,
                                              expression:
                                                "workCondition.CanWorkAtCleanRoom",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              _vm.workCondition
                                                .CanWorkAtCleanRoom,
                                              false
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanWorkAtCleanRoom",
                                                false
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("否 (No)")]),
                                      ]),
                                    ]),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-6" }),
                  !_vm.workCondition.CanWorkAtCleanRoom
                    ? _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c("ValidationProvider", {
                              attrs: {
                                rules: {
                                  required: !_vm.workCondition
                                    .CanWorkAtCleanRoom
                                    ? true
                                    : false,
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "field-title" },
                                          [
                                            !_vm.workCondition
                                              .CanWorkAtCleanRoom
                                              ? _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v(" * ")]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                style: { color: _vm.fontColor },
                                              },
                                              [
                                                _vm._v(" 說明 "),
                                                _c(
                                                  "span",
                                                  { staticClass: "en-text" },
                                                  [_vm._v("Explain")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "field-value" },
                                          [
                                            _c("el-input", {
                                              staticClass: "w-100",
                                              attrs: {
                                                type: "textarea",
                                                rows: 3,
                                                maxlength: "200",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.workCondition
                                                    .CanWorkAtCleanRoomDesc,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.workCondition,
                                                    "CanWorkAtCleanRoomDesc",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "workCondition.CanWorkAtCleanRoomDesc",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        errors[0]
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(errors[0]) + " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(
                                            " 是否可接受使用顯微鏡之工作 "
                                          ),
                                          _c("p", { staticClass: "en-text" }, [
                                            _vm._v(
                                              "Can accept using microscope at work"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "field-radio" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanUseMicroscope,
                                              expression:
                                                "workCondition.CanUseMicroscope",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              _vm.workCondition
                                                .CanUseMicroscope,
                                              true
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanUseMicroscope",
                                                true
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("是 (Yes)")]),
                                      ]),
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanUseMicroscope,
                                              expression:
                                                "workCondition.CanUseMicroscope",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              _vm.workCondition
                                                .CanUseMicroscope,
                                              false
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanUseMicroscope",
                                                false
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("否 (No)")]),
                                      ]),
                                    ]),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-6" }),
                  !_vm.workCondition.CanUseMicroscope
                    ? _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c("ValidationProvider", {
                              attrs: {
                                rules: {
                                  required: !_vm.workCondition.CanUseMicroscope
                                    ? true
                                    : false,
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "field-title" },
                                          [
                                            !_vm.workCondition.CanUseMicroscope
                                              ? _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v(" * ")]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                style: { color: _vm.fontColor },
                                              },
                                              [
                                                _vm._v(" 說明 "),
                                                _c(
                                                  "span",
                                                  { staticClass: "en-text" },
                                                  [_vm._v("Explain")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "field-value" },
                                          [
                                            _c("el-input", {
                                              staticClass: "w-100",
                                              attrs: {
                                                type: "textarea",
                                                rows: 3,
                                                maxlength: "200",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.workCondition
                                                    .CanUseMicroscopeDesc,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.workCondition,
                                                    "CanUseMicroscopeDesc",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "workCondition.CanUseMicroscopeDesc",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        errors[0]
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(errors[0]) + " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(
                                            " 是否可配合單位工具及產品搬運 "
                                          ),
                                          _c("p", { staticClass: "en-text" }, [
                                            _vm._v(
                                              "Can cooperate with Unit work tools and delivery of product"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "field-radio" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanCarryObjects,
                                              expression:
                                                "workCondition.CanCarryObjects",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              _vm.workCondition.CanCarryObjects,
                                              true
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanCarryObjects",
                                                true
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("是 (Yes)")]),
                                      ]),
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanCarryObjects,
                                              expression:
                                                "workCondition.CanCarryObjects",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              _vm.workCondition.CanCarryObjects,
                                              false
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanCarryObjects",
                                                false
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("否 (No)")]),
                                      ]),
                                    ]),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-6" }),
                  !_vm.workCondition.CanCarryObjects
                    ? _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c("ValidationProvider", {
                              attrs: {
                                rules: {
                                  required: !_vm.workCondition.CanCarryObjects
                                    ? true
                                    : false,
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "field-title" },
                                          [
                                            !_vm.workCondition.CanCarryObjects
                                              ? _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v(" * ")]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                style: { color: _vm.fontColor },
                                              },
                                              [
                                                _vm._v(" 說明 "),
                                                _c(
                                                  "span",
                                                  { staticClass: "en-text" },
                                                  [_vm._v("Explain")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "field-value" },
                                          [
                                            _c("el-input", {
                                              staticClass: "w-100",
                                              attrs: {
                                                type: "textarea",
                                                rows: 3,
                                                maxlength: "200",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.workCondition
                                                    .CanCarryObjectsDesc,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.workCondition,
                                                    "CanCarryObjectsDesc",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "workCondition.CanCarryObjectsDesc",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        errors[0]
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(errors[0]) + " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(
                                            " 是否可接受長時間定點性/走動性久站 "
                                          ),
                                          _c("p", { staticClass: "en-text" }, [
                                            _vm._v(
                                              "Can accept long time fix point/ walking/ long standing"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "field-radio" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanStandLongTime,
                                              expression:
                                                "workCondition.CanStandLongTime",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              _vm.workCondition
                                                .CanStandLongTime,
                                              true
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanStandLongTime",
                                                true
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("是 (Yes)")]),
                                      ]),
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanStandLongTime,
                                              expression:
                                                "workCondition.CanStandLongTime",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              _vm.workCondition
                                                .CanStandLongTime,
                                              false
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanStandLongTime",
                                                false
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("否 (No)")]),
                                      ]),
                                    ]),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-6" }),
                  !_vm.workCondition.CanStandLongTime
                    ? _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c("ValidationProvider", {
                              attrs: {
                                rules: {
                                  required: !_vm.workCondition.CanStandLongTime
                                    ? true
                                    : false,
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "field-title" },
                                          [
                                            !_vm.workCondition.CanStandLongTime
                                              ? _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v(" * ")]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                style: { color: _vm.fontColor },
                                              },
                                              [
                                                _vm._v(" 說明 "),
                                                _c(
                                                  "span",
                                                  { staticClass: "en-text" },
                                                  [_vm._v("Explain")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "field-value" },
                                          [
                                            _c("el-input", {
                                              staticClass: "w-100",
                                              attrs: {
                                                type: "textarea",
                                                rows: 3,
                                                maxlength: "200",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.workCondition
                                                    .CanStandLongTimeDesc,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.workCondition,
                                                    "CanStandLongTimeDesc",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "workCondition.CanStandLongTimeDesc",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        errors[0]
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(errors[0]) + " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(
                                            " 是否可接受接觸化學藥品工作 "
                                          ),
                                          _c("p", { staticClass: "en-text" }, [
                                            _vm._v("Work can touch chemicals"),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "field-radio" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanWorkWithChemicals,
                                              expression:
                                                "workCondition.CanWorkWithChemicals",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              _vm.workCondition
                                                .CanWorkWithChemicals,
                                              true
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanWorkWithChemicals",
                                                true
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("是 (Yes)")]),
                                      ]),
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanWorkWithChemicals,
                                              expression:
                                                "workCondition.CanWorkWithChemicals",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              _vm.workCondition
                                                .CanWorkWithChemicals,
                                              false
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanWorkWithChemicals",
                                                false
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("否 (No)")]),
                                      ]),
                                    ]),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-6" }),
                  !_vm.workCondition.CanWorkWithChemicals
                    ? _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c("ValidationProvider", {
                              attrs: {
                                rules: {
                                  required: !_vm.workCondition
                                    .CanWorkWithChemicals
                                    ? true
                                    : false,
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "field-title" },
                                          [
                                            !_vm.workCondition
                                              .CanWorkWithChemicals
                                              ? _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v(" * ")]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                style: { color: _vm.fontColor },
                                              },
                                              [
                                                _vm._v(" 說明 "),
                                                _c(
                                                  "span",
                                                  { staticClass: "en-text" },
                                                  [_vm._v("Explain")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "field-value" },
                                          [
                                            _c("el-input", {
                                              staticClass: "w-100",
                                              attrs: {
                                                type: "textarea",
                                                rows: 3,
                                                maxlength: "200",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.workCondition
                                                    .CanWorkWithChemicalsDesc,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.workCondition,
                                                    "CanWorkWithChemicalsDesc",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "workCondition.CanWorkWithChemicalsDesc",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        errors[0]
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(errors[0]) + " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(
                                            " 是否可接受英文介面機台操作 "
                                          ),
                                          _c("p", { staticClass: "en-text" }, [
                                            _vm._v(
                                              "Work can accept machine English interface"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "field-radio" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanOperateMachineInEnglish,
                                              expression:
                                                "workCondition.CanOperateMachineInEnglish",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              _vm.workCondition
                                                .CanOperateMachineInEnglish,
                                              true
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanOperateMachineInEnglish",
                                                true
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("是 (Yes)")]),
                                      ]),
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCondition
                                                  .CanOperateMachineInEnglish,
                                              expression:
                                                "workCondition.CanOperateMachineInEnglish",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              _vm.workCondition
                                                .CanOperateMachineInEnglish,
                                              false
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCondition,
                                                "CanOperateMachineInEnglish",
                                                false
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("否 (No)")]),
                                      ]),
                                    ]),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-6" }),
                  !_vm.workCondition.CanOperateMachineInEnglish
                    ? _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c("ValidationProvider", {
                              attrs: {
                                rules: {
                                  required: !_vm.workCondition
                                    .CanOperateMachineInEnglish
                                    ? true
                                    : false,
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "field-title" },
                                          [
                                            !_vm.workCondition
                                              .CanOperateMachineInEnglish
                                              ? _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v(" * ")]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                style: { color: _vm.fontColor },
                                              },
                                              [
                                                _vm._v(" 說明 "),
                                                _c(
                                                  "span",
                                                  { staticClass: "en-text" },
                                                  [_vm._v("Explain")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "field-value" },
                                          [
                                            _c("el-input", {
                                              staticClass: "w-100",
                                              attrs: {
                                                type: "textarea",
                                                rows: 3,
                                                maxlength: "200",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.workCondition
                                                    .CanOperateMachineInEnglishDesc,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.workCondition,
                                                    "CanOperateMachineInEnglishDesc",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "workCondition.CanOperateMachineInEnglishDesc",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        errors[0]
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(errors[0]) + " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("div", { staticClass: "field-title" }, [
                        _c("span", { style: { color: _vm.fontColor } }, [
                          _vm._v(" 過去兩年內是否請過長假 "),
                          _c("p", { staticClass: "en-text" }, [
                            _vm._v(
                              "For the past 2 years if had request long term leave"
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "field-radio" }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.workCondition.HasLongTermVacation,
                                expression: "workCondition.HasLongTermVacation",
                              },
                            ],
                            attrs: { type: "radio" },
                            domProps: {
                              value: true,
                              checked: _vm._q(
                                _vm.workCondition.HasLongTermVacation,
                                true
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.workCondition,
                                  "HasLongTermVacation",
                                  true
                                )
                              },
                            },
                          }),
                          _c("span", [_vm._v("是 (Yes)")]),
                        ]),
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.workCondition.HasLongTermVacation,
                                expression: "workCondition.HasLongTermVacation",
                              },
                            ],
                            attrs: { type: "radio" },
                            domProps: {
                              value: false,
                              checked: _vm._q(
                                _vm.workCondition.HasLongTermVacation,
                                false
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.workCondition,
                                  "HasLongTermVacation",
                                  false
                                )
                              },
                            },
                          }),
                          _c("span", [_vm._v("否 (No)")]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "col-md-6" }),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("div", { staticClass: "field-title" }, [
                        _c("span", { style: { color: _vm.fontColor } }, [
                          _vm._v(" 說明 "),
                          _c("span", { staticClass: "en-text" }, [
                            _vm._v("Explain"),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "field-value" },
                        [
                          _c("el-input", {
                            staticClass: "w-100",
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              maxlength: "200",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.workCondition.HasLongTermVacationDesc,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.workCondition,
                                  "HasLongTermVacationDesc",
                                  $$v
                                )
                              },
                              expression:
                                "workCondition.HasLongTermVacationDesc",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveWorkCondition)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }